import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4d1c455c")
const _hoisted_1 = { class: "card page--limited" }
const _hoisted_2 = {
  key: 0,
  class: "p-p-3"
}
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Titolo *", -1)
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "p-field p-col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "short_description" }, "Descrizione breve *", -1)
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "p-field p-col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "content" }, "Contenuto *", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "image" }, "Immagine", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", { class: "p-text-secondary" }, "Formati supportati: JPG, PNG, GIF (max 5MB)", -1)
const _hoisted_16 = {
  key: 0,
  class: "p-field p-col-12 p-md-6"
}
const _hoisted_17 = { class: "image-preview" }
const _hoisted_18 = { class: "p-field p-col-12" }
const _hoisted_19 = { class: "p-field-checkbox" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "published",
  class: "p-ml-2"
}, "Pubblicato", -1)
const _hoisted_21 = {
  key: 1,
  class: "p-p-3"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Image = _resolveComponent("Image")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: _ctx.isNew ? 'Nuova News' : 'Modifica News',
      backRoute: _ctx.backRoute,
      onOnDelete: _ctx.onDelete,
      deleteDisabled: _ctx.isNew
    }, {
      saveButton: _withCtx(() => [
        _withDirectives(_createVNode(_component_Button, {
          class: "p-mr-1",
          icon: "pi pi-save",
          onClick: _ctx.onSubmit
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.save'),
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _: 1
    }, 8, ["title", "backRoute", "onOnDelete", "deleteDisabled"]),
    (_ctx.news)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputText, {
                  id: "title",
                  modelValue: _ctx.news.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.news.title = $event)),
                  class: _normalizeClass({'p-invalid': _ctx.submitted && !_ctx.news.title})
                }, null, 8, ["modelValue", "class"]),
                (_ctx.submitted && !_ctx.news.title)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_6, "Il titolo è obbligatorio"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Textarea, {
                  id: "short_description",
                  modelValue: _ctx.news.short_description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.news.short_description = $event)),
                  autoResize: true,
                  rows: "3",
                  class: _normalizeClass({'p-invalid': _ctx.submitted && !_ctx.news.short_description})
                }, null, 8, ["modelValue", "class"]),
                (_ctx.submitted && !_ctx.news.short_description)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_9, "La descrizione breve è obbligatoria"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_Editor, {
                  id: "content",
                  modelValue: _ctx.news.content,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.news.content = $event)),
                  editorStyle: "height: 320px",
                  class: _normalizeClass({'p-invalid': _ctx.submitted && !_ctx.news.content})
                }, null, 8, ["modelValue", "class"]),
                (_ctx.submitted && !_ctx.news.content)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_12, "Il contenuto è obbligatorio"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_FileUpload, {
                  mode: "basic",
                  name: "image",
                  accept: "image/*",
                  maxFileSize: 5000000,
                  auto: false,
                  chooseLabel: "Scegli immagine",
                  onSelect: _ctx.onImageSelect
                }, null, 8, ["onSelect"]),
                _hoisted_15
              ]),
              (_ctx.news.image_url || _ctx.imagePreview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Image, {
                        src: _ctx.imagePreview || _ctx.news.image_url,
                        alt: "Anteprima",
                        width: "250",
                        preview: ""
                      }, null, 8, ["src"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_InputSwitch, {
                    id: "published",
                    modelValue: _ctx.publishedSwitch,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.publishedSwitch = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_20
                ])
              ])
            ])
          ], 32)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_ProgressSpinner)
        ]))
  ]))
}